export default (state, getters) => id => {
    return getters['user/permit'](id);
}